/* ============================================
   GLIDER JEWELS – Theme JS
   ============================================ */

document.addEventListener('DOMContentLoaded', function () {

  // ── Custom cursor ──
  const cursor = document.getElementById('cursor');
  const ring = document.getElementById('cursorRing');
  if (cursor && ring) {
    let mx = 0, my = 0, rx = 0, ry = 0;
    document.addEventListener('mousemove', e => { mx = e.clientX; my = e.clientY; });
    (function animateCursor() {
      if (cursor) { cursor.style.left = mx + 'px'; cursor.style.top = my + 'px'; }
      rx += (mx - rx) * 0.15; ry += (my - ry) * 0.15;
      if (ring) { ring.style.left = rx + 'px'; ring.style.top = ry + 'px'; }
      requestAnimationFrame(animateCursor);
    })();
    document.querySelectorAll('a, button').forEach(el => {
      el.addEventListener('mouseenter', () => {
        cursor.style.width = '14px'; cursor.style.height = '14px';
        ring.style.width = '48px'; ring.style.height = '48px';
      });
      el.addEventListener('mouseleave', () => {
        cursor.style.width = '8px'; cursor.style.height = '8px';
        ring.style.width = '32px'; ring.style.height = '32px';
      });
    });
  }

  // ── Scroll reveal ──
  const reveals = document.querySelectorAll('.reveal');
  if (reveals.length) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e, i) => {
        if (e.isIntersecting) {
          setTimeout(() => e.target.classList.add('visible'), 80);
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    reveals.forEach(el => io.observe(el));

    // Staggered children
    document.querySelectorAll('.services__grid, .process__steps, .testimonials__grid, .why__stats, .collection-grid').forEach(grid => {
      grid.querySelectorAll('.reveal').forEach((el, i) => {
        el.style.transitionDelay = (i * 0.1) + 's';
      });
    });
  }

  // ── Sticky header ──
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 60);
    });
  }

  // ── Mobile menu ──
  const toggle = document.querySelector('.mobile-menu-toggle');
  const mobileNav = document.querySelector('.mobile-nav');
  if (toggle && mobileNav) {
    toggle.addEventListener('click', () => {
      mobileNav.classList.toggle('open');
      document.body.style.overflow = mobileNav.classList.contains('open') ? 'hidden' : '';
    });
    mobileNav.querySelectorAll('a').forEach(a => {
      a.addEventListener('click', () => {
        mobileNav.classList.remove('open');
        document.body.style.overflow = '';
      });
    });
  }

  // ── Product gallery thumbnails ──
  const thumbs = document.querySelectorAll('.product-gallery__thumb');
  const mainImg = document.querySelector('.product-gallery__main');
  if (thumbs.length && mainImg) {
    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        mainImg.src = thumb.src;
        thumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
      });
    });
  }

  // ── Variant selector ──
  const variantBtns = document.querySelectorAll('.variant-btn');
  variantBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      variantBtns.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
    });
  });

  // ── Cart quantity ──
  document.querySelectorAll('.cart-item__qty').forEach(qtyEl => {
    const minus = qtyEl.querySelector('[data-action="minus"]');
    const plus = qtyEl.querySelector('[data-action="plus"]');
    const display = qtyEl.querySelector('span');
    if (minus && plus && display) {
      minus.addEventListener('click', () => {
        let val = parseInt(display.textContent);
        if (val > 1) display.textContent = val - 1;
      });
      plus.addEventListener('click', () => {
        let val = parseInt(display.textContent);
        display.textContent = val + 1;
      });
    }
  });

});
